import React from 'react';
import { convertCurrency } from '@/helpers/convertCurrency';
import { Planogram } from '@/store/Planogram/findAll';
import { ColumnsType } from 'antd/lib/table';
import { BarcodeOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { CellWithTooltip } from '@/components/DataView/EditableTable';
import { PlanogramProductCreateFromProduct } from '../PlanogramReview/type';
import {
    StatusLocked,
    StatusUnlocked,
    NewValue,
    ProductInfo,
    BarCodeArea,
    ProductTitle,
    ProductBarCode,
} from './styles';

export type PlanogramWithChanges = Planogram & {
    price_final_in_cents_after: number;
    price_list_in_cents_after: number;
    status_after: string;
    alert_level: string;
    alert_level_after: string;
    standard_amount_after?: number;
    enabled_to_calculate_margin?: boolean;
};

export const columns: ColumnsType<PlanogramProductCreateFromProduct> = [
    {
        title: 'Produto',
        dataIndex: 'name',
        width: 150,
        ellipsis: { showTitle: true },
        render: (_, record) => {
            return (
                <ProductInfo>
                    <Tooltip title={record.name}>
                        <ProductTitle>{record.name}</ProductTitle>
                    </Tooltip>
                    <BarCodeArea>
                        <BarcodeOutlined
                            style={{ marginRight: 8, color: '#B0B0B0' }}
                        />
                        <ProductBarCode>
                            {record.bar_code ||
                                'Nenhum código de barras cadastrado'}
                        </ProductBarCode>
                    </BarCodeArea>
                </ProductInfo>
            );
        },
    },
    {
        title: 'Cód. de planograma',
        width: 170,
        render: (_, record) => {
            return <NewValue>{record.planogram_code}</NewValue>;
        },
    },
    {
        title: 'Qtd. padrão',
        width: 120,
        render: (_, record: PlanogramProductCreateFromProduct) => {
            return <NewValue>{record.standard_amount}</NewValue>;
        },
    },
    {
        title: 'Nível de alerta',
        width: 130,
        render: (_, record: PlanogramProductCreateFromProduct) => {
            return <NewValue>{record.alert_level}</NewValue>;
        },
    },
    {
        title: 'Qnt. em estoque',
        width: 150,
        render: (_, record: PlanogramProductCreateFromProduct) => {
            return <NewValue>{record.stock_amount}</NewValue>;
        },
    },
    {
        title: 'Preço Lista',
        width: 110,
        render: (_, record: PlanogramProductCreateFromProduct) => {
            return (
                <CellWithTooltip
                    valueCell={convertCurrency('', record.price_list_in_cents)}
                    ptbrCurrency
                />
            );
        },
    },
    {
        title: 'Preço App',
        width: 110,
        render: (_, record: PlanogramProductCreateFromProduct) => {
            return (
                <CellWithTooltip
                    valueCell={convertCurrency('', record.price_final_in_cents)}
                    ptbrCurrency
                />
            );
        },
    },
    {
        width: 250,
        title: 'Status',
        render: (_, record: PlanogramProductCreateFromProduct) => {
            const { status } = record;

            if (status === 'lock') {
                return (
                    <StatusLocked>Bloqueado para abastecimento</StatusLocked>
                );
            }

            if (status === 'lockSold') {
                return <StatusLocked>Bloqueado para venda</StatusLocked>;
            }

            return <StatusUnlocked>Desbloqueado</StatusUnlocked>;
        },
    },
];
